/**
 * Storyblok slugs for the vaccination section.
 *
 * Each slug is identical to the public URL it is served at — `vaccination/vaccin` is both the
 * Storyblok path and the route folder under `src/app/(vaccinations)`. That pairing is load-bearing:
 * the sitemap emits `story.full_slug` verbatim, so any slug that drifts from its route silently
 * becomes a 404 in the sitemap.
 *
 * The overview slugs address folder start pages. Storyblok stores those with a trailing slash
 * (`vaccination/`), but the CDN resolves the unslashed form too — the same shape `vardcentraler`
 * has used since long before this section existed.
 */
export const VACCINATION_ROOT_SLUG = "vaccination"
export const VACCINATION_CLINICS_SLUG = `${VACCINATION_ROOT_SLUG}/mottagningar`
export const VACCINES_SLUG = `${VACCINATION_ROOT_SLUG}/vaccin`
export const TRAVEL_VACCINES_SLUG = `${VACCINATION_ROOT_SLUG}/resevaccin`
export const SERVICES_SLUG = "tjanster"
export const COOPERATION_PARTNERS_SLUG = `${VACCINATION_ROOT_SLUG}/foretag`

/**
 * A vaccine's config lives under whichever of the two type folders it belongs to, so callers that
 * only know the vaccine slug match across both rather than tracking the split themselves.
 */
export const vaccineConfigSlugPattern = (slug: string) => `${VACCINATION_ROOT_SLUG}/*/${slug}/config`

/**
 * A config story's public page path: configs are stored at `<page>/config`, so the page is that
 * slug with the suffix removed. The `/?` covers Storyblok writing the trailing slash on some
 * stories and not others.
 */
export const stripConfigSuffix = (fullSlug: string) => fullSlug.replace(/\/config\/?$/, "")
